// LIBRARIES //
import React from 'react';

// COMPONENTS //
import FooterButtons from 'components/shared/FooterButtons';

// HELPERS //
import { getTranslatedString } from 'helpers/i18n';

const PAD_DETAIL_TAB_INDEX = 5;

const DrawerFooter = ({ closeDrawer, tabIndex }) => (
  <FooterButtons
    hideSubmitButton={tabIndex !== PAD_DETAIL_TAB_INDEX}
    submitName={getTranslatedString('landlordPortal.tenantOverview.saveChanges')}
    backName={getTranslatedString('landlordPortal.tenantOverview.close')}
    backAction={closeDrawer}
    position={'static'}
  />
);

export default DrawerFooter;
